// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__pQS1V","is-yellow":"Banner_is-yellow__jNefu"};